import { Endpoint } from "@constructor/services";
function apiFragment(pathname) {
  return new Endpoint({ prefix: "/api/fragment", pathname });
}
const apiProjectFragmentsGet = apiFragment("fragments/projects/:projectName");
function useFragmentVersionsRequest(requester) {
  return requester.entity(apiProjectFragmentsGet).response().setup((projectName) => ({ params: { projectName } }));
}
export {
  useFragmentVersionsRequest as u
};
//# sourceMappingURL=api.js.map
